import React from 'react';

import Tracker from '../../common/Tracker';
import api from "../../../api/api.js"

import "../../../css/LocationDetail.css";

const CATEGORY = "location details";

var DetailMapWidget = (props) => {
       if(!props.location){
           return;
       }
       let center = {
            lat: props.location.latitude,
            lng: props.location.longitude
       }
       let markerIcon = "https://firebasestorage.googleapis.com/v0/b/infusion-center-locator.appspot.com/o/attribute_icons%252Fimg-map-pin.png?alt=media"
       let markers = "icon:" + markerIcon + "|" + center.lat + "," + center.lng
       let imgSrc = "https://maps.googleapis.com/maps/api/staticmap?markers="+ markers + "&size=640x320&key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw";
       let onClick = () => {
           Tracker.trackEvent(CATEGORY, "get directions click", props.location.name, "");
           api.trackLocationClick(props.location.key, "directions_clicks");

           window.open("https://maps.google.com?saddr=Current+Location&daddr="+center.lat+","+center.lng, "_target=blank");
       }

       return (
           <div className="mapContainer container minPadded" style={{
               flex:1,
               backgroundImage: "url('" + imgSrc + "')",
               backgroundSize: "cover",
               backgroundRepeat: "no-repeat",
               backgroundPosition: "50% 50%"}}>
               <div style={{position: "absolute", bottom: 0, left: 0, right: 0}}>
                   <div className="detailMapGradient container vertical-center">
                       <div className="detailMapAddress flex1">
                           <div>
                               {props.location.address1}
                           </div>
                           <div>
                               {props.location.address2}
                           </div>
                           <div>
                               {props.location.city}, {props.location.stateAbbr} {props.location.postCode}
                           </div>
                        </div>
                        <div className="container flex1" style={{flexDirection: "row-reverse", paddingRight: "24px"}}>
                            <TransparentButton label="GET DIRECTIONS" onClick={onClick}/>

                        </div>

                    </div>

               </div>
           </div>

       )
}

var TransparentButton = (props) =>{
    return (
        <div className="transparentButton" onTouchTap={props.onClick}>
            {props.label}
        </div>
    )
}

export default DetailMapWidget;



// WEBPACK FOOTER //
// ./src/components/locator/details/DetailMapWidget.js